import type { JSX } from 'react';
import type { ITpoFlexBiometryData } from '@common/validation/customControls/tpoFlex/tpoFlexBiometrySchema';
import { FilesUrlBase } from '@common/enums';
import { FormGroupRead } from '@frontend/components/pages/customControls/utils/v1/FormGroupRead';
import { getSelectedLanguage } from '@frontend/translate';
import { useProcessActivityReadContext } from '@frontend/utils/hooks/useProcessActivityContext';
import { RenderAssetThumbnails } from '../../../../episodes/common';

export function TpoFlexBiometryRead(): JSX.Element {
    const { processActivity } = useProcessActivityReadContext<ITpoFlexBiometryData>();
    const { customControlData } = processActivity;

    return (
        <>
            <RenderAssetThumbnails
                assets={customControlData.assets}
                id={processActivity.id}
                urlBase={FilesUrlBase.processActivities}
            />
            <FormGroupRead
                label={getSelectedLanguage().common.remark}
                value={customControlData.examination}
            />
        </>
    );
}
